export function synchronizeCommunityFilterSelection(
  previousOptions: string[],
  selectedValues: string[],
  updatedOptions: string[],
): string[] {
  const selectedAllPreviousOptions = previousOptions.length > 0
    && previousOptions.every(option => selectedValues.includes(option));

  if (selectedAllPreviousOptions) {
    return updatedOptions;
  }

  return selectedValues.filter(value => updatedOptions.includes(value));
}
